import { render, staticRenderFns } from "./ProductCategoryBasedReportComponent.vue?vue&type=template&id=51ff1b30&scoped=true"
import script from "./ProductCategoryBasedReportComponent.vue?vue&type=script&lang=js"
export * from "./ProductCategoryBasedReportComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductCategoryBasedReportComponent.vue?vue&type=style&index=0&id=51ff1b30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ff1b30",
  null
  
)

export default component.exports